import { useCallback, useEffect, useRef, useState } from "react";
import BASE_CONFIG from "./config";
import { ChatEvents } from "./constants";

const CONNECTING = 0;
const OPEN = 1;
const CLOSING = 2;
const CLOSED = 3;

function ChatConnection({
  connected,
  setConnected,
  setRegistered,
  onJoinRoom,
  onMessage,
  onReceiveReceipt,
  messageBuffer,
  setMessageBuffer,
  onAssignAgent,
  closeRoom,
  roomToken,
  updateMessage,
  deleteMessage,
  AssignmentRequested,
  BotAssigned,
  onDeliveryReceipt,
  onReadReceipt,
  RemoveBot,
  onSetRoomProperties,
  setInitialized,
  onVCButtonVisibility
}) {
  const [connectionAttempts, setConnectionAttempts] = useState(0);

  // Need to use ref here to avoid stale closure problem
  const onJoinRoomRef = useRef();
  const onMessageRef = useRef();
  const onReceiveReceiptRef = useRef();
  const socketRef = useRef();
  const connectionMonitor = useRef();
  const pingMonitor = useRef();
  const agentAssignmentRef = useRef();
  const closeRoomRef = useRef();
  const updateMessageref = useRef()
  const deleteMessageref = useRef()
  const AssignmentRequestedref = useRef()
  const BotAssignedref = useRef()
  const onDeliveryReceiptRef = useRef()
  const onReadReceiptRef = useRef()
  const RemoveBotRef = useRef()
  const SetRoomPropertiesRef = useRef()
  const VCButtonVisibilityRef = useRef()
  onJoinRoomRef.current = onJoinRoom;
  onMessageRef.current = onMessage;
  AssignmentRequestedref.current = AssignmentRequested
  onReceiveReceiptRef.current = onReceiveReceipt;
  agentAssignmentRef.current = onAssignAgent;
  closeRoomRef.current = closeRoom;
  updateMessageref.current = updateMessage
  deleteMessageref.current = deleteMessage
  BotAssignedref.current = BotAssigned
  onDeliveryReceiptRef.current = onDeliveryReceipt
  onReadReceiptRef.current = onReadReceipt
  RemoveBotRef.current = RemoveBot
  SetRoomPropertiesRef.current = onSetRoomProperties
  VCButtonVisibilityRef.current = onVCButtonVisibility
  const emitMessage = useCallback((message) => {
    if (socketRef?.current?.send) {
      socketRef?.current?.send(JSON.stringify(message));
    }
    else {
      //console.log("reconnect socket")
      connectSocket()
    }
  }, []);

  const registerSocketListeners = useCallback(() => {
    socketRef.current.onclose = (event) => {
      //console.log("Connection closed");
      //console.log(event);
      setConnected(false);
      socketRef.current = null;
    };

    socketRef.current.onerror = (event) => {
      //console.log(event);
    };

    socketRef.current.onmessage = (event) => {
      let message = JSON.parse(event.data);
      switch (message.action) {
        case ChatEvents.RegistrationSuccess: {
          setRegistered(true);
          break;
        }
        case ChatEvents.JoinRoom: {
          onJoinRoomRef.current(message.roomId);
          break;
        }
        case ChatEvents.Message: {
          onMessageRef.current(message);
          break;
        }
        case ChatEvents.MessageReceived: {
          onReceiveReceiptRef.current(message);
          break;
        }
        case ChatEvents.AgentAssigned: {
          agentAssignmentRef.current(message);
          break;
        }
        case ChatEvents.RoomClose: {
          closeRoomRef.current(message);
          break;
        }
        case ChatEvents.MessageUpdate: {
          updateMessageref.current(message)
          break;
        }
        case ChatEvents.MessageDelete: {
          deleteMessageref.current(message)
          break;
        }
        case ChatEvents.QueuedForAssignment: {
          AssignmentRequestedref.current(message)
          break;
        }
        case ChatEvents.BotAssigned: {
          BotAssignedref.current(message)
          break;
        }
        case ChatEvents.MessageDelivered: {
          onDeliveryReceiptRef.current(message)
          break;
        }
        case ChatEvents.MessageRead: {
          onReadReceiptRef.current(message)
          break;
        }
        case ChatEvents.RemoveBot: {
          RemoveBotRef.current(message)
          break;
        }
        case ChatEvents.SetRoomProperties: {
          SetRoomPropertiesRef.current(message)
          break;
        }
        case ChatEvents.VCButtonVisibility:{
          VCButtonVisibilityRef.current(message)
          break;
        }
        
        default:
          break;
      }
    };
  }, [setConnected, setRegistered]);

  const connectSocket = useCallback(() => {
    //console.log("connect socket called");
    if (socketRef.current && socketRef.current.readyState != CLOSED) {
      return;
    }
    socketRef.current = new WebSocket(BASE_CONFIG.SOCKET_URL);

    socketRef.current.onopen = (_event) => {
      registerSocketListeners();
      setConnected(true);
    };
  }, [registerSocketListeners, setConnected]);

  // useEffect(() => {
  //   // Setup a ping to server
  //   if (connected) {
  //     if (pingMonitor.current) {
  //       clearInterval(pingMonitor.current);
  //       pingMonitor.current = null;
  //     }

  //     pingMonitor.current = setInterval(function () {
  //       //console.log("sending ping");
  //       emitMessage({
  //         action: ChatEvents.Ping,
  //         auth: roomToken,
  //         sentAt: new Date().toISOString(),
  //       });
  //     }, 10000);
  //   }
  // }, [connected, roomToken]);

  //Start connecting socket once state has been hydrated
  useEffect(() => {
    if (!connected) {
      //console.log("attempting connection" + connectionAttempts);
      connectSocket();
    }
    if (!connected && !connectionMonitor.current) {
      connectionMonitor.current = setInterval(function () {
        setConnectionAttempts((attempts) => attempts + 1);
      }, 5000);
    } else if (connected && connectionMonitor.current) {
      //setInitialized(false)
      clearInterval(connectionMonitor.current);
      connectionMonitor.current = null;
    }
  }, [connected, connectionAttempts, connectSocket]);

  // Send all messages in message buffer
  useEffect(() => {
    if (connected &&  socketRef.current && socketRef.current?.readyState == OPEN &&  Object.keys(messageBuffer).length > 0) {
      for (let value of Object.values(messageBuffer)) {
        emitMessage(value);
      }
      setMessageBuffer({});
    }
  }, [connected, messageBuffer, setMessageBuffer]);
}
export default ChatConnection;
